import * as React from 'react';
import { observer } from 'mobx-react';
import Link from '@src/components/link';

const styles = require('./index.less');

const ReturnBtn = ({ store }) => {
  store.use();
  return (
    <div className={styles.returnRoot}>
      <Link
        className={styles.returnBtn}
        onClick={() => {
          store.onReturnClick();
        }}
      />
    </div>
  );
};

export default observer(ReturnBtn);
